/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { useMediaQuery, useTheme } from "@mui/material";

import NavbarAccountMenu from "../../features/account/containers/NavbarAccountMenu/NavbarAccountMenu";
import { DesktopCartHeader } from "../../features/cart/components/DesktopCartHeader";
import TestIds from "../../testIds";

import MobileBottomNav from "./bottombar/MobileBottomNav";
import DesktopSidebarNav from "./sidebar/DesktopSidebarNav";
import HeaderMountains from "./HeaderMountains";

const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (isMobile) {
    return <MobileBottomNav />;
  }

  return (
    <>
      <header
        data-testid={TestIds.components.layout.header.component}
        className={`
          sticky top-0 z-[1100] flex w-full items-center bg-forest-green-900 pt-3 pr-6 pb-1
          pl-[min(21vw,var(--sidenav-gutter))]
        `}
      >
        <div className="flex w-full gap-(--gap-xl)">
          <div className="flex flex-1 items-center">
            <DesktopCartHeader />
          </div>

          <NavbarAccountMenu />
        </div>

        <HeaderMountains />
      </header>

      <DesktopSidebarNav />
    </>
  );
};

export default Header;
